var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3438 0H1.41478C0.633417 0 0 0.63426 0 1.41666V15.5832C0 16.3656 0.633417 16.9999 1.41478 16.9999H23.3438C24.1252 16.9999 24.7586 16.3656 24.7586 15.5832V1.41666C24.7586 0.63426 24.1252 0 23.3438 0Z",
    fill: "#FFF4EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5558 12.1529C11.7129 12.8811 10.6197 13.321 9.42488 13.321C6.75873 13.321 4.59766 11.1319 4.59766 8.43138C4.59766 5.73087 6.75873 3.54178 9.42488 3.54178C10.6197 3.54178 11.7129 3.98165 12.5558 4.70982C13.3986 3.98165 14.4919 3.54178 15.6867 3.54178C18.3528 3.54178 20.5139 5.73087 20.5139 8.43138C20.5139 11.1319 18.3528 13.321 15.6867 13.321C14.4919 13.321 13.3986 12.8811 12.5558 12.1529Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5508 12.1529C13.5885 11.2562 14.2467 9.9217 14.2467 8.43138C14.2467 6.94105 13.5885 5.60656 12.5508 4.70982C13.3936 3.98165 14.4869 3.54178 15.6817 3.54178C18.3478 3.54178 20.5089 5.73087 20.5089 8.43138C20.5089 11.1319 18.3478 13.321 15.6817 13.321C14.4869 13.321 13.3936 12.8811 12.5508 12.1529Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5592 4.70973C13.597 5.60648 14.2552 6.94097 14.2552 8.43129C14.2552 9.92162 13.597 11.2561 12.5592 12.1529C11.5215 11.2561 10.8633 9.92162 10.8633 8.43129C10.8633 6.94097 11.5215 5.60648 12.5592 4.70973Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMasterCard);
export default __webpack_public_path__ + "static/media/NewMasterCard.5935d946.svg";
export { ForwardRef as ReactComponent };